/* eslint-disable @typescript-eslint/no-explicit-any */
import Grid from '@config/Grid/Grid'
import Tile from '@/shared/components/Tile/Tile'
import { useState } from 'react'

import styles from '@/features/mobile-app/MobileAppManagement.module.scss'
import HomePage from '@/features/mobile-app/layouts/HomePage/HomePage'
import RestaurantPage from '@/features/mobile-app/layouts/RestaurantPage/RestaurantPage'
import Drawer from '@/features/mobile-app/components/Drawer/Drawer'
import TransparentDrawer from '@/features/mobile-app/components/TransparentDrawer/TransparentDrawer'
import Menu from '@/features/mobile-app/layouts/Menu/Menu'

import MobileAppForm from '@/features/mobile-app/layouts/MobileAppForm/MobileAppForm'

function MobileAppManagement() {
  const [isTransparentDrawerOpen, setIsTransparentDrawerOpen] = useState(false)
  const [isMenuCardOpen, setIsMenuCardOpen] = useState(false)

  return (
    <Grid>
      <div
        id="tour-mobile-preview"
        className={`${styles.phonePreviewWrapper} start-2 col-4 align-start`}
      >
        <Tile
          color="gradient"
          customPadding="1rem 2rem 1.5rem 2rem"
          id="appManagement"
          customBackground
        >
          {isMenuCardOpen ? (
            <Menu setIsMenuCardOpen={setIsMenuCardOpen} />
          ) : (
            <HomePage isTransparentDrawerOpen={isTransparentDrawerOpen}>
              <RestaurantPage setIsMenuCardOpen={setIsMenuCardOpen} />
            </HomePage>
          )}
          <Drawer
            setIsTransparentDrawerOpen={setIsTransparentDrawerOpen}
            isTransparentDrawerOpen={isTransparentDrawerOpen}
          />
          <TransparentDrawer
            setIsTransparentDrawerOpen={setIsTransparentDrawerOpen}
            isTransparentDrawerOpen={isTransparentDrawerOpen}
          />
        </Tile>
      </div>
      <div
        id="tour-mobile-form"
        className={`${styles.mobileAppManagementWrapper} start-6 col-7`}
      >
        <Tile color="black">
          <MobileAppForm />
        </Tile>
      </div>
    </Grid>
  )
}

export default MobileAppManagement
